import { ArrowUpRight, Instagram, MessageCircle } from "lucide-react";
import { Overline, Reveal } from "./Reveal";
import { site, waLink, WA_MESSAGES } from "../config/site";
import { trackEvent } from "../lib/analytics";
import { Magnetic } from "./Magnetic";

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
  </svg>
);

export const FinalCTA = () => (
  <section id="contato" data-testid="final-cta-section" className="relative overflow-hidden py-24 lg:py-32">
    <div aria-hidden="true" className="absolute inset-x-0 top-0 mx-auto h-[500px] max-w-4xl rounded-full bg-[radial-gradient(ellipse,rgba(199,205,214,0.08),transparent_65%)] blur-3xl" />
    <div className="relative mx-auto grid max-w-7xl items-center gap-16 px-4 sm:px-6 lg:grid-cols-2 lg:gap-20 lg:px-12">
      <div>
        <Reveal>
          <Overline>Próximo passo</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-3xl font-bold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            Seu negócio não precisa de mais do mesmo.{" "}
            <span className="chrome-text">Precisa do próximo passo certo.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-gb-gray sm:text-lg">
            Conte para a GOBAX o que você deseja alcançar. Atendimento direto pelo WhatsApp,
            com quem realmente executa o seu projeto.
          </p>
        </Reveal>
        <Reveal delay={0.26}>
          <ul className="mt-9 space-y-3.5 text-sm text-gb-silver sm:text-base">
            {["Conversa direta com os fundadores", "Diagnóstico da sua presença digital", "Caminho recomendado para o seu negócio"].map((item) => (
              <li key={item} className="flex items-center gap-3">
                <span className="h-1.5 w-1.5 rounded-full bg-gb-silver" aria-hidden="true" />
                {item}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>

      <Reveal delay={0.15}>
        <div className="card-chrome relative overflow-hidden rounded-2xl p-8 text-center sm:p-12" data-testid="whatsapp-contact-card">
          <div aria-hidden="true" className="grid-bg absolute inset-0 opacity-60" />
          <div className="relative">
            <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_18px_50px_-12px_rgba(37,211,102,0.55)]">
              <WhatsAppIcon className="h-9 w-9" />
            </span>
            <h3 className="mt-8 font-display text-2xl font-bold">Fale com a GOBAX agora</h3>
            <p className="mt-3 font-mono text-sm tracking-[0.12em] text-gb-silver" data-testid="whatsapp-number-display">
              {site.whatsappDisplay}
            </p>
            <p className="mx-auto mt-4 max-w-xs text-sm leading-relaxed text-gb-gray">
              Toque no botão e a conversa já abre com uma mensagem pronta. Simples assim.
            </p>
            <Magnetic className="w-full sm:w-auto">
              <a
                href={waLink(WA_MESSAGES.especialista)}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent("whatsapp_click", { location: "final_cta" })}
                data-testid="final-cta-whatsapp-btn"
                className="btn-chrome mt-9 inline-flex w-full items-center justify-center gap-2 rounded-full px-7 py-4 text-sm font-semibold sm:w-auto sm:px-10"
              >
                <MessageCircle className="h-4 w-4" aria-hidden="true" />
                Falar com um especialista
                <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
              </a>
            </Magnetic>
            {site.instagramUrl && (
              <a
                href={site.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="final-cta-instagram-link"
                className="mt-6 inline-flex items-center gap-2 text-xs text-gb-gray transition-colors hover:text-gb-white"
              >
                <Instagram className="h-4 w-4" aria-hidden="true" />
                ou acompanhe @gobaxdigitalhub no Instagram
              </a>
            )}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
